/* HH Warenkorb (Marco 22.10.2026): "Lieferung ca. Fr. 23.10. bis Di. 27.10."
   Gerechnet im Browser nach deutscher Zeit, nicht in Liquid: Shopify cacht die Seiten, ein
   Datum aus dem Server waere am naechsten Morgen veraltet. Eine Bestellung bis zum
   Annahmeschluss an einem Werktag zaehlt fuer diesen Tag, sonst fuer den naechsten Werktag;
   von dort 1 bis 3 Werktage wie in § 5 der AGB (Theme-Einstellung HH Warenkorb).
   Werktage sind hier Montag bis Freitag ohne bundesweite Feiertage; der Samstag zaehlt
   rechtlich mit, bleibt aber bewusst weg, damit die Angabe nicht zu frueh liegt.
   Das Element steht in Abschnitten, die cart.js und cart-drawer.js per innerHTML ersetzen;
   connectedCallback rechnet deshalb bei jedem Einfuegen neu. */
(function () {
  if (customElements.get('hh-lieferzeit')) return;

  const TAGE = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];

  // Ostersonntag nach der Gaussschen Formel (anonymer gregorianischer Algorithmus).
  function ostern(jahr) {
    const a = jahr % 19, b = Math.floor(jahr / 100), c = jahr % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const monat = Math.floor((h + l - 7 * m + 114) / 31);
    const tag = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(jahr, monat - 1, tag);
  }

  const TAG_MS = 86400000;
  const feiertageCache = {};
  function feiertage(jahr) {
    if (feiertageCache[jahr]) return feiertageCache[jahr];
    const o = ostern(jahr);
    const liste = [
      Date.UTC(jahr, 0, 1),   // Neujahr
      o - 2 * TAG_MS,          // Karfreitag
      o + 1 * TAG_MS,          // Ostermontag
      Date.UTC(jahr, 4, 1),   // Tag der Arbeit
      o + 39 * TAG_MS,         // Christi Himmelfahrt
      o + 50 * TAG_MS,         // Pfingstmontag
      Date.UTC(jahr, 9, 3),   // Tag der Deutschen Einheit
      Date.UTC(jahr, 11, 25), // 1. Weihnachtstag
      Date.UTC(jahr, 11, 26), // 2. Weihnachtstag
    ];
    return (feiertageCache[jahr] = new Set(liste));
  }

  function werktag(t) {
    const tag = new Date(t).getUTCDay();
    return tag !== 0 && tag !== 6 && !feiertage(new Date(t).getUTCFullYear()).has(t);
  }

  function naechsterWerktag(t) {
    do { t += TAG_MS; } while (!werktag(t));
    return t;
  }

  function plusWerktage(t, n) {
    for (let i = 0; i < n; i++) t = naechsterWerktag(t);
    return t;
  }

  // Heutiges Datum und Stunde in Berlin, als UTC-Mitternacht des Kalendertags.
  function jetztBerlin() {
    const teile = {};
    new Intl.DateTimeFormat('de-DE', {
      timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23',
    }).formatToParts(new Date()).forEach((p) => { teile[p.type] = p.value; });
    return { tag: Date.UTC(+teile.year, +teile.month - 1, +teile.day), stunde: +teile.hour };
  }

  function format(t) {
    const d = new Date(t);
    const tt = String(d.getUTCDate()).padStart(2, '0');
    const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
    return `${TAGE[d.getUTCDay()]} ${tt}.${mm}.`;
  }

  function lieferspanne(schluss, von, bis, jetzt) {
    let start = jetzt.tag;
    if (!werktag(start) || jetzt.stunde >= schluss) start = naechsterWerktag(start);
    return [plusWerktage(start, von), plusWerktage(start, bis)];
  }

  class HhLieferzeit extends HTMLElement {
    connectedCallback() {
      const schluss = Number(this.dataset.schluss) || 14;
      const von = Number(this.dataset.von) || 1;
      const bis = Math.max(Number(this.dataset.bis) || 3, von);
      const [a, b] = lieferspanne(schluss, von, bis, jetztBerlin());
      this.textContent = `Lieferung ca. ${format(a)} bis ${format(b)}`;
    }
  }

  customElements.define('hh-lieferzeit', HhLieferzeit);
  window.hhLieferspanne = lieferspanne;
})();
